export const LocalStorageItems = {
	RedirectAfterLoginUrl: 'redirectAfterLogin'
} as const;
